import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import './Empty.css';

export const Empty = ({
  imageId,
  image,
  titleId,
  title,
  bodyId,
  body,
  opacity,
}) => (
  <div className="empty-container" style={{ opacity }}>
    <Image id={imageId} className="empty-image" src={image} />
    <p id={titleId} className="empty-title">
      {title}
    </p>
    <p id={bodyId} className="empty-body">
      {body}
    </p>
  </div>
);

Empty.propTypes = {
  imageId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyId: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  opacity: PropTypes.number,
};

Empty.defaultProps = {
  opacity: 1,
};



// WEBPACK FOOTER //
// ./src/components/views/Empty.js